import { MovesGener } from './moveGenerator';
import { getMoveType } from './moveDetector';
import {
    TYPE_0_PASS,
    TYPE_1_SINGLE,
    TYPE_2_PAIR,
    TYPE_3_TRIPLE,
    TYPE_4_BOMB,
    TYPE_5_KING_BOMB,
    TYPE_6_3_1,
    TYPE_7_3_2,
    TYPE_8_SERIAL_SINGLE,
    TYPE_9_SERIAL_PAIR,
    TYPE_10_SERIAL_TRIPLE,
    TYPE_11_SERIAL_3_1,
    TYPE_12_SERIAL_3_2,
    TYPE_13_4_2,
    TYPE_14_4_22,
    uniqueMoves,
} from './moveConstants';
import * as ms from './moveSelector';

export function getLegalCardPlayActions(playerHandCards, rivalMove) {
    const mg = new MovesGener(playerHandCards);
    const rivalType = getMoveType(rivalMove);
    const rivalMoveType = rivalType.type;
    const rivalMoveLen = rivalType.len || 1;
    let moves = [];

    if (rivalMoveType === TYPE_0_PASS) {
        moves = mg.genMoves();
    } else if (rivalMoveType === TYPE_1_SINGLE) {
        moves = ms.filterType1Single(mg.genType1Single(), rivalMove);
    } else if (rivalMoveType === TYPE_2_PAIR) {
        moves = ms.filterType2Pair(mg.genType2Pair(), rivalMove);
    } else if (rivalMoveType === TYPE_3_TRIPLE) {
        moves = ms.filterType3Triple(mg.genType3Triple(), rivalMove);
    } else if (rivalMoveType === TYPE_4_BOMB) {
        moves = ms.filterType4Bomb(mg.genType4Bomb().concat(mg.genType5KingBomb()), rivalMove);
    } else if (rivalMoveType === TYPE_5_KING_BOMB) {
        moves = [];
    } else if (rivalMoveType === TYPE_6_3_1) {
        moves = ms.filterType6_3_1(mg.genType6_3_1(), rivalMove);
    } else if (rivalMoveType === TYPE_7_3_2) {
        moves = ms.filterType7_3_2(mg.genType7_3_2(), rivalMove);
    } else if (rivalMoveType === TYPE_8_SERIAL_SINGLE) {
        moves = ms.filterType8SerialSingle(mg.genType8SerialSingle(rivalMoveLen), rivalMove);
    } else if (rivalMoveType === TYPE_9_SERIAL_PAIR) {
        moves = ms.filterType9SerialPair(mg.genType9SerialPair(rivalMoveLen), rivalMove);
    } else if (rivalMoveType === TYPE_10_SERIAL_TRIPLE) {
        moves = ms.filterType10SerialTriple(mg.genType10SerialTriple(rivalMoveLen), rivalMove);
    } else if (rivalMoveType === TYPE_11_SERIAL_3_1) {
        moves = ms.filterType11Serial3_1(mg.genType11Serial3_1(rivalMoveLen), rivalMove);
    } else if (rivalMoveType === TYPE_12_SERIAL_3_2) {
        moves = ms.filterType12Serial3_2(mg.genType12Serial3_2(rivalMoveLen), rivalMove);
    } else if (rivalMoveType === TYPE_13_4_2) {
        moves = ms.filterType13_4_2(mg.genType13_4_2(), rivalMove);
    } else if (rivalMoveType === TYPE_14_4_22) {
        moves = ms.filterType14_4_22(mg.genType14_4_22(), rivalMove);
    }

    if (rivalMoveType !== TYPE_0_PASS && rivalMoveType !== TYPE_4_BOMB && rivalMoveType !== TYPE_5_KING_BOMB) {
        moves = moves.concat(mg.genType4Bomb(), mg.genType5KingBomb());
    }

    if (rivalMove.length !== 0) {
        moves.push([]);
    }

    moves.forEach((m) => m.sort((a, b) => a - b));
    moves.sort((a, b) => {
        if (a.length !== b.length) return a.length - b.length;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return a[i] - b[i];
        }
        return 0;
    });

    return uniqueMoves(moves);
}
